import { createAsyncThunk } from '@reduxjs/toolkit';

import { resetAccountsSlice } from '../../../../accounts/slices/accounts/accounts.slice.ts';
import { resetAuthFormData } from '../../../../accounts/slices/auth/auth.slice.ts';
import { resetAppStateSlice } from '../../../../learn/slices/app-state/app-state.slice.ts';
import { resetLessonState } from '../../../../learn/slices/lesson/lesson.slice.ts';
import { resetProgressSlice } from '../../../../learn/slices/progress/progress.slice.ts';

import { ThunkApiConfigType } from '../../../store/main.store.ts';

import { resetAppRedirectionSlice } from '../../app-redirection-slice/app-redirection.slice.ts';

import { APP_LIFECYCLE_SLICE_NAME } from '../app-lifecycle.slice.types.ts';

export const resetSlicesStateThunk = createAsyncThunk<void, undefined, ThunkApiConfigType>(
  `${APP_LIFECYCLE_SLICE_NAME}/resetSlicesState`,
  (_, thunkAPI) => {
    thunkAPI.dispatch(resetAppRedirectionSlice());
    thunkAPI.dispatch(resetAccountsSlice());
    thunkAPI.dispatch(resetAuthFormData());
    thunkAPI.dispatch(resetAppStateSlice());
    thunkAPI.dispatch(resetLessonState());
    thunkAPI.dispatch(resetProgressSlice());
  }
);
